module.exports = __webpack_public_path__ + "static/media/vabank1.e60915d7.jpg";